import { IMask } from 'react-imask';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

export const DEFAULT_PHONE_NUMBERS = ['0000000000', '0000000001', '0000000002'];
export function isFakePhone(phone: string) {
  return DEFAULT_PHONE_NUMBERS.includes(phone);
}

export const normalizePhoneNumber = (value: string, mask = true) => {
  const masked = IMask.createMask({
    mask: '(#00) 000-0000',
    definitions: {
      '#': /[2-9]/,
    },
  });
  masked.resolve(value);
  return mask ? masked.value : masked.unmaskedValue;
};

export const validatePhoneNumber = (value: string, country: CountryCode = 'US') => isValidPhoneNumber(value, country);
